module.exports = __webpack_public_path__ + "img/serve11.fbcc7d35.png";